module.exports = __webpack_public_path__ + "img/right_ear.ea0ac221.svg";